import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material'
import React from 'react'
import { Theme } from '../../constants/theme'

const RadioField: React.FC<{
  clientErrorText?: string
  isInline?: boolean
  label?: string
  name: string
  onChange: (e: any) => void
  options?: { label: string; value: any }[]
  value: string
}> = ({ clientErrorText, isInline, label, name, onChange, options, value }) => {
  if (!options?.length) {
    return null
  }

  return (
    <FormControl
      error={Boolean(clientErrorText)}
      sx={{
        fontSize: 12,
        mt: 0.625, // default theme spacing value is 8px, and we want this to be 5px
      }}
    >
      {label && (
        <FormLabel
          id={name}
          sx={(theme: Theme) => ({
            fontSize: 12,
            fontWeight: 700,
            color: theme.text,
          })}
        >
          {label}
        </FormLabel>
      )}
      <RadioGroup
        aria-labelledby={label ? name : undefined}
        name={name}
        onChange={onChange}
        row={isInline}
        value={value}
      >
        {options.map((option) => {
          return (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={
                <Radio
                  sx={(theme: Theme) => ({
                    color: theme.primary,
                    '&.Mui-checked': {
                      color: theme.primary,
                    },
                  })}
                />
              }
              label={option.label}
            />
          )
        })}
      </RadioGroup>
      {clientErrorText && (
        <FormHelperText error={true}>{clientErrorText}</FormHelperText>
      )}
    </FormControl>
  )
}

export default RadioField
